// Las mismas reglas que valida el backend (AppConfigService.validate), para avisar antes de guardar.
const VERSION_PATTERN = /^\d+(\.\d+){0,3}([-+].*)?$/;

export const isValidVersion = (value) => VERSION_PATTERN.test(String(value || '').trim());

const toParts = (value) => String(value).trim().split(/[-+]/)[0].split('.').map(Number);

export const compareVersions = (a, b) => {
  const left = toParts(a);
  const right = toParts(b);
  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    const diff = (left[i] || 0) - (right[i] || 0);
    if (diff !== 0) return diff;
  }
  return 0;
};

/** Devuelve el mensaje del primer problema de la política, o null si se puede guardar. */
export const policyError = ({ minVersion = '', suggestedVersion = '', latestVersion = '', storeUrl = '' }) => {
  const min = minVersion.trim();
  const suggested = suggestedVersion.trim();
  const latest = latestVersion.trim();
  const url = storeUrl.trim();
  const fields = [['La versión mínima', min], ['La versión sugerida', suggested], ['La última versión publicada', latest]];
  for (const [label, value] of fields) {
    if (value && !isValidVersion(value)) return `${label} no es una versión válida (ejemplo: 1.4.0)`;
  }
  if (url && !url.startsWith('https://')) return 'El enlace de la tienda tiene que empezar con https://';
  if (min && suggested && compareVersions(suggested, min) < 0) return 'La versión sugerida no puede ser menor que la mínima';
  if (min || suggested) {
    if (!latest) return 'Indicá la última versión publicada en la tienda';
    if (!url) return 'Cargá el enlace de la tienda para que la app pueda mandar a actualizar';
    if (min && compareVersions(min, latest) > 0) return 'La versión mínima no puede ser mayor que la última publicada';
    if (suggested && compareVersions(suggested, latest) > 0) return 'La versión sugerida no puede ser mayor que la última publicada';
  }
  return null;
};

/** "2026-10-30T15:40:50.919033" -> "30/10/2026 15:40". Si no se puede leer, devuelve el texto tal cual. */
export const formatDateTime = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(String(value || ''));
  return match ? `${match[3]}/${match[2]}/${match[1]} ${match[4]}:${match[5]}` : String(value || '');
};
